import { useState, useEffect, useRef } from "react";
import { createModel } from "hox";
import { cceService } from "../../cceService";
import { ICreditCardTabEnum, ISupplierPriceDialog, ICceMaterialDetail, ICceDetail, ISupplierOfferDetails, ISupplierMaterialDetails } from "../../cceTypes";
import { IMaterialDetail } from "@/views/base/material/materialService";
import { message } from "antd";
import useGlobalModel from "@/model/globalModel";
import { useLockFn } from "ahooks";
import { convertRes2Blob } from "@/utils/exportFile";
import moment from "moment";
import { useDictModel } from "@/views/base/dict/dictModel";


export const useCceDetailModel = createModel(function () {
    const { user: { shopCode, shopName }, setLoadingInfo } = useGlobalModel(({ user }) => [user]);
    const { getTreeNodeName } = useDictModel(() => []);

    const initFormVal = {
        // id: "",
        code: "",
        shopName,
    } as ICceDetail;
    const [tabActive, setTabActive] = useState<ICreditCardTabEnum>(ICreditCardTabEnum.BASE_DETAIL) //tabs 选中

    //编辑缓存
    const [editFormVal, setEditFormVal] = useState<ICceDetail>(initFormVal);
    const [editList, setEditList] = useState<ICceMaterialDetail[]>([]);

    //新增缓存
    const [addFormVal, setAddFormVal] = useState<ICceDetail>(initFormVal);
    const [addList, setAddList] = useState<ICceMaterialDetail[]>([]);

    //添加商品弹框
    const [materialDialog, setMaterialDialog] = useState<boolean>(false);

    //重置页面缓存
    const resetPageCache = (mode: string) => {
        if (mode === "edit") {
            setEditFormVal(initFormVal);
            setEditList([]);
        }
        else if (mode === "add") {
            setAddFormVal(initFormVal);
            setAddList([]);
        }
        setTabActive(ICreditCardTabEnum.BASE_DETAIL);
    }

    //主单修改
    const updateFormVal = (mode: string, val?: object | null) => {
        const setFormVal = mode === "edit" ? setEditFormVal : setAddFormVal;
        setFormVal((origin: any) => val ? { ...origin, ...val } : initFormVal);
    }


    //获取一条数据
    const getCceDetailOne = async (id: string) => {
        let { retData } = await cceService.one(id);
        if (retData) {
            setEditFormVal(retData);
        }
        return retData;
    };

    //报价单新增 | 编辑
    const insertOrUpdateCce = useLockFn(async (mode: string) => {
        const formVal = mode === 'edit' ? editFormVal : addFormVal;
        let data = {
            ...formVal,
            currencyName: getTreeNodeName(formVal.currency),
            shopCode,
            saleCode: formVal.saleRealCode,
            confirmTime: formVal?.confirmTime ? moment(formVal?.confirmTime).format('YYYY-MM-DD') : undefined,
            signingTime: formVal?.signingTime ? moment(formVal?.signingTime).format('YYYY-MM-DD') : undefined,
            informTime: formVal?.informTime ? moment(formVal?.informTime).format('YYYY-MM-DD') : undefined,
            presentationTime: formVal?.presentationTime ? moment(formVal?.presentationTime).format('YYYY-MM-DD') : undefined,
            receiptTime: formVal?.receiptTime ? moment(formVal?.receiptTime).format('YYYY-MM-DD') : undefined,
            sailSchedule: formVal?.sailSchedule ? moment(formVal?.sailSchedule).format('YYYY-MM-DD') : undefined,
        };
        //新增
        if (mode === "edit") {
            let { retData } = await cceService.update({ ...data, id: editFormVal.id as string, code: editFormVal.code ?? "" });
            getCceDetailOne(editFormVal.id)
            message.success("保存成功")
            return retData;
        } else {
            let { retData } = await cceService.insert(data);
            message.success("新增成功,自动转换至编辑详情页")
            return retData;
        }
    })

    //导出
    const exportCce = async () => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            let result = await cceService.detailExport(editFormVal.code, shopCode);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }

    //报价单明细下载模板
    const downloadTpl = async () => {
        let result = await cceService.downloadTpl();
        convertRes2Blob(result);
    }

    return {
        /***field***/
        editFormVal,
        editList,
        addFormVal,
        addList,
        tabActive, setTabActive,
        materialDialog, setMaterialDialog,
        /***method***/
        getCceDetailOne,
        updateFormVal,
        insertOrUpdateCce,
        resetPageCache,
        exportCce,
        downloadTpl
    }
});